// extracted by mini-css-extract-plugin
export default {"panel":"agZyZA","host":"bgZyZA"};